/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Groupbyroles2Inputs */

const en_common_groupbyroles2 = /** @type {(inputs: Common_Groupbyroles2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Group by roles`)
};

/**
* | output |
* | --- |
* | "Group by roles" |
*
* @param {Common_Groupbyroles2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_groupbyroles2 = /** @type {((inputs?: Common_Groupbyroles2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Groupbyroles2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_groupbyroles2(inputs)
});
export { common_groupbyroles2 as "common_groupByRoles" }